"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultBugDispatcherOptions = {
    options: {
        imageSprite: 'fly-sprite.png',
        scoreBase: 10,
        minBugs: 2,
        maxBugs: 20,
        maxDelay: 5000,
        minDelay: 3000,
        bugWidth: 13,
        bugHeight: 14,
        frameWidth: 160,
        frameHeight: 160,
        spriteSheetframes: {
            stop: {
                columns: 6,
                row: 1,
            },
            walk: {
                columns: 6,
                row: 1,
            },
            die: {
                columns: 6,
                row: 1,
            }
        },
        classNames: {
            default: "",
            stop: "",
            walk: "",
            die: ""
        }
    }
};
exports.default = defaultBugDispatcherOptions;
// minDelay: 500,
// maxDelay: 10000,
// minSpeed: 5,
// maxSpeed: 10,
// maxLargeTurnDeg: 150,
// maxSmallTurnDeg: 10,
// maxWiggleDeg: 5,
// canFly: true,
// canDie: true,
// numDeathTypes: 3,
// monitorMouseMovement: false,
// eventDistanceToBug: 40,
// minTimeBetweenMultipy: 1000,
// wingsOpen: false,
// flySpeed: 40,
// edge_resistance: 50,
// spriteFrameWidth: 16,
// spriteFrameheigth: 16,
